import { call, put, takeEvery } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import {
  FETCH_RECOMMENDATION_REQUEST,
  RECOMMENDATION_ENGINES,
} from './AiRecommendations.constants';
import {
  getEinsteinRecommendations,
  getGenAiRecommendations,
} from '../../../../../services/abstractors/common/recommendations/aiRecommendations';
import { fetchRecommendationSuccess } from './AiRecommendations.actions';

function* fetchRecommendationSaga({
  payload: { pageName, strategy, productId, engine, brand, gender },
}) {
  try {
    let products = [];
    if (engine === RECOMMENDATION_ENGINES.EINSTEIN) {
      products = yield call(getEinsteinRecommendations, { productId, strategy });
    } else if (engine === RECOMMENDATION_ENGINES.GEN_AI) {
      const xappURLConfig = yield call(getUnbxdXappConfigs);
      products = yield call(getGenAiRecommendations, {
        productId,
        brand,
        strategy,
        xappURLConfig,
        gender,
      });
    }
    yield put(fetchRecommendationSuccess({ pageName, strategy, products }));
  } catch (error) {
    logger.error({
      error: `Error occurred in AiRecommendationsSaga at fetchRecommendationSaga method - ${
        error?.message || error?.errorMessage
      }`,
      extraData: {
        component: 'AiRecommendationsSaga - fetchRecommendationSaga',
      },
    });
  }
}

export default function* AiRecommendationsSaga() {
  yield takeEvery(FETCH_RECOMMENDATION_REQUEST, fetchRecommendationSaga);
}
